type Environment = "prod" | "demo" | "custom"
/**
    * @description this variable is used to set the environment of the application. choose between "prod", "demo" or "custom"
    * if "custom" make sure to change the switch custom case
*/
export const env: Environment = "demo" as Environment
let csl = false;

export class PlugpointEnvironment {
    public static endpoint = "https://app.plugpoint.ro/helios/api";
    public static token = "4a46889db102438faa83b0b8151898a6";
    public static wssEndpoint = "wss://app.plugpoint.ro:8443/overwatch/centralSystem/";
    public static haproxyEndpoint = "https://app.plugpoint.ro/helios/";
    public static url = "https://app.plugpoint.ro"
    public static consoleDisabled = !csl ? true : false;
}
switch (env) {

    case "demo":
        PlugpointEnvironment.endpoint = "https://t2.plugpoint.ro/helios/api";
        PlugpointEnvironment.wssEndpoint = "wss://t2.plugpoint.ro:8443/overwatch/centralSystem/";
        PlugpointEnvironment.url = "https://t2.plugpoint.ro"
        PlugpointEnvironment.haproxyEndpoint = "https://t2.plugpoint.ro/helios/";
        break;

    case "custom":
        PlugpointEnvironment.endpoint = "";
        PlugpointEnvironment.wssEndpoint = "";
        PlugpointEnvironment.url = ""
        break;

    default:
        break;
}
